export default function Toast({ msg, type = 'ok' }) {
  const bg = type === 'error' ? '#e05757' : type === 'warn' ? '#f5a623' : '#00e5a0';
  return (
    <div style={{
      position: 'fixed', bottom: 28, right: 28, zIndex: 9999,
      background: bg, color: '#060b10',
      padding: '12px 20px', borderRadius: 10,
      fontWeight: 700, fontSize: 13,
      boxShadow: `0 8px 32px ${bg}55`,
      animation: 'fadein 0.2s ease',
    }}>
      {msg}
    </div>
  );
}
